import { AutoMap } from "@automapper/classes";
import { Cassette } from "./cassette";
import { EMesureTerrainStatus } from "./enums/mesure-terrrain-status";
import { Securite } from "./securite";
import { ZoneSamplingCondition } from "./zone-sampling-condition";

export class ZoneMeasure {
    @AutoMap()
    Code!: string;
    @AutoMap()
    IsCancelled!: boolean;
    @AutoMap()
    MeasureReferenceCode!: string;
    @AutoMap()
    MeasureReferenceName!: string;
    @AutoMap()
    Status!: EMesureTerrainStatus;
    @AutoMap()
    Localisation!: string;
    @AutoMap()
    TextColor!: string;
    @AutoMap()
    Color!: string;
    // @AutoMap()
    // SamplingID: number;
    @AutoMap()
    Observation?: string;
    @AutoMap()
    PumpWithBattery!: boolean;
    @AutoMap()
    Cassette!: Cassette;

    @AutoMap()
    PoseSecurite!: Securite;
    @AutoMap()
    DeposeSecurite!: Securite;
    @AutoMap()
    ZoneSamplingCondition!: ZoneSamplingCondition;
    @AutoMap()
    IsDepose!: boolean;
    @AutoMap()
    HasFan!: boolean;

    public constructor(init?: Partial<ZoneMeasure>) {
        Object.assign(this, init);
    }
}